import { create } from 'zustand';

import { RunWithSubsetName } from '../components/breadcrumb';

interface MatterProcessingData {
  hasCompletedRuns: boolean;
  hasProcessingRuns: boolean;
  allProcessingRuns: RunWithSubsetName[];
  mostRecentRun: RunWithSubsetName | null;
}

interface MatterProcessingStore {
  // Store processing state by matterId
  processingState: Record<string, MatterProcessingData>;

  // Set processing state for a matter
  setProcessingState: (matterId: string, state: MatterProcessingData) => void;

  // Get processing state for a matter
  getProcessingState: (matterId: string) => MatterProcessingData | undefined;

  // Clear processing state for a matter
  clearProcessingState: (matterId: string) => void;
}

export const useMatterProcessingStore = create<MatterProcessingStore>((set, get) => ({
  processingState: {},

  setProcessingState: (matterId: string, state: MatterProcessingData) =>
    set((store) => ({
      processingState: {
        ...store.processingState,
        [matterId]: state,
      },
    })),

  getProcessingState: (matterId: string) => get().processingState[matterId],

  clearProcessingState: (matterId: string) =>
    set((store) => {
      const { [matterId]: _, ...rest } = store.processingState;
      return { processingState: rest };
    }),
}));
